<!-- eslint-disable @angular-eslint/template/eqeqeq -->
@if ((kontrakt$ | async); as kontrakt) {
<form [formGroup]="form" class="container-fluid ps-0">
    <div class="row">
        <!-- U3 -->
        @if (kontrakt.isLeveransvirke) {
        <div class="col-4">
            <rask-input
                class="w-100"
                label="Namn"
                formControlName="atgardsnamn"
                [raskDisabledControl]="atgard.isUtfort"
                raskVirkeskopRule [messageId]="['leveransvirkeAtgardNamn']">
            </rask-input>
        </div>
        <div class="col-8">
            <div class="row">
                <div class="col-6">
                    <rask-datepicker class="w-100" label="F.Produktionsdatum fr.o.m."
                        [raskDisabledControl]="atgard.isUtfort"
                        formControlName="foreslagetProduktionsdatumFrom"
                        (change)="atgardForeslagetProduktionsdatumChanged()"
                        raskVirkeskopRule [messageId]="['foreslagetProduktionsdatumFrom']"
                        [entityGuid]="atgard.guid"></rask-datepicker>
                </div>
                <div class="col-6">
                    <rask-datepicker class="w-100" label="F.Produktionsdatum t.o.m."
                        [raskDisabledControl]="atgard.isUtfort"
                        formControlName="foreslagetProduktionsdatumTom"
                        (change)="atgardForeslagetProduktionsdatumChanged()"
                        raskVirkeskopRule [messageId]="['foreslagetProduktionsdatumTom']"
                        [entityGuid]="atgard.guid"></rask-datepicker>
                </div>
            </div>
        </div>
        <div class="col-12">
            <rask-textmultiline class="w-100" label="Produktionsstatus">
                <span>{{$safeNavigationMigration(atgard.arbetsorder?.produktionsStatus) | produktionsstatus}}</span>
            </rask-textmultiline>
        </div>
        @if (isGrot) {
        <div class="col-4 mb-3">
            <rask-datepicker
                [raskDisabledControl]="atgard.isReadonly"
                aid="input"
                class="w-100"
                label="Datum skördat"
                infoText="Ange slutskördat datum för ytan."
                formControlName="datumSkordat">
            </rask-datepicker>
        </div>
        }
        <div class="col-4 d-flex mb-3" [ngClass]="isGrot ? 'offset-4' : 'offset-8'">
            <div class="ms-auto mt-auto">
                <rask-button color="primary" negative (click)="onRemoveAtgard()">Ta
                    bort åtgärd</rask-button>
            </div>
        </div>
        } @else {
        <div class="col-4">
            <div class="d-flex flex-row">
                <div class="col-12">
                    <rask-input-number
                        [inputProcessor]="numberDecimalProcessor"
                        class="w-100"
                        label="Nettoareal HA"
                        formControlName="nettoareal"
                        (change)="nettoarealChanged()"
                        [raskDisabledControl]="atgard.isReadonly"
                        raskVirkeskopRule [messageId]="['atgardNettoareal']" [entityGuid]="atgard.guid">
                    </rask-input-number>
                </div>
                @if (showUtbyteIconWarning) {
                <div class="utbyte-warning">
                    <rask-icon icon="fa-light fa-square-exclamation" popoverContainer="body"
                        class="atgard-utbyte-icon">
                        <div class="body">
                            <ul class="fa-ul m-0">
                                <ng-container>
                                    <li>
                                        {{utbyteIconWarningText}}
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </rask-icon>
                </div>
                }
            </div>
        </div>
        <div class="col-4">
            <fieldset formGroupName="planerare">
                <rask-search
                    [raskDisabledControl]="atgard.isReadonly"
                    aid="inputAnsvarigFaltplanering"
                    class="w-100"
                    label="Ansvarig för Fältplanering"
                    bindLabel="name"
                    bindValue="userName"
                    formControlName="userName"
                    typeToSearchText=""
                    [typeaheadFn]="searchForAnsvarigPlanerareTypeAhead"
                    loadingText="Laddar..."
                    notFoundText="Ingen träff"
                    [minTermLength]="3"
                    [compareWith]="ansvarigPlanerareCompareWith"
                    [selected]="atgard.planerare">
                </rask-search>
            </fieldset>
        </div>
        @if (isGrot && !hasKoppladRundvirke) {
        <div class="col-4">
            <rask-datepicker
                [raskDisabledControl]="atgard.isReadonly"
                aid="input"
                class="w-100"
                label="Datum skördat"
                infoText="Ange slutskördat datum för ytan."
                formControlName="datumSkordat">
            </rask-datepicker>
        </div>
        }
        <div class="col-8">
            <div class="row">
                <div class="col-6">
                    <rask-simple-selector class="w-100" label="Tillgänglighet skog"
                        bindLabel="text"
                        bindValue="value"
                        [values]="atgard.tillganglighetItems"
                        formControlName="tillganglighetSkog"
                        [raskDisabledControl]="atgard.isReadonly"
                        raskVirkeskopRule [messageId]="['atgardTillganglighetSkog']"
                        [entityGuid]="atgard.guid">
                    </rask-simple-selector>
                </div>
                <div class="col-6">
                    <rask-simple-selector class="w-100" label="Tillgänglighet väg"
                        [values]="atgard.tillganglighetItems"
                        bindLabel="text"
                        bindValue="value"
                        formControlName="tillganglighetVag"
                        [raskDisabledControl]="atgard.isReadonly"
                        raskVirkeskopRule [messageId]="['atgardTillganglighetVag']"
                        [entityGuid]="atgard.guid">
                    </rask-simple-selector>
                </div>
            </div>
        </div>
        <div class="col-4">
            <rask-input-number [useDecimalProcessor]="true"
                [raskDisabledControl]="atgard.isReadonly"
                class="w-100"
                label="Skotningsavstånd"
                formControlName="skotningsavstand"
                raskVirkeskopRule [messageId]="['atgardSkotningsavstand']"
                [entityGuid]="atgard.guid"
                [isDecimal]="false">
            </rask-input-number>
        </div>
        <div class="col-4">
            <rask-simple-selector
                [raskDisabledControl]="atgard.isReadonly"
                class="w-100"
                label="Bärighet"
                formControlName="barighet"
                bindLabel="text"
                bindValue="value"
                [values]="barighetItems"
                raskVirkeskopRule [messageId]="['atgardBarighet']" [entityGuid]="atgard.guid">
            </rask-simple-selector>
        </div>
        <div class="col-4">
            <rask-simple-selector
                [raskDisabledControl]="atgard.isReadonly"
                class="w-100"
                label="Ytstruktur"
                formControlName="ytstruktur"
                bindLabel="text"
                bindValue="value"
                [values]="ytstrukturItems"
                raskVirkeskopRule [messageId]="['atgardYtstruktur']" [entityGuid]="atgard.guid">
            </rask-simple-selector>
        </div>
        <div class="col-4">
            <rask-simple-selector
                [raskDisabledControl]="atgard.isReadonly"
                class="w-100"
                label="Lutning"
                formControlName="lutning"
                bindLabel="text"
                bindValue="value"
                [values]="lutningItems"
                raskVirkeskopRule [messageId]="['atgardLutning']" [entityGuid]="atgard.guid">
            </rask-simple-selector>
        </div>
        @if (!kontrakt.isGrot) {
        <div class="col-4">
            @if (!atgard.isMedelstamCalculated) {
            <rask-input-number
                [useDecimalProcessor]="true"
                [raskDisabledControl]="atgard.isReadonly"
                class="w-100"
                label="Medelstam m3fub/stam"
                formControlName="medelstam"
                raskVirkeskopRule [messageId]="['atgardMedelstam']" [entityGuid]="atgard.guid">
            </rask-input-number>
            } @else {
            <rask-input-number
                [value]="atgard.medelstam"
                class="w-100"
                [disabled]="true"
                label="Medelstam m3fub/stam">
            </rask-input-number>
            }
        </div>
        <div class="col-4">
            @if (!atgard.isGrundytaForeCalculated) {
            <rask-input-number
                [useDecimalProcessor]="true"
                class="w-100"
                [raskDisabledControl]="atgard.isReadonly"
                label="Grundyta före avverkning (m²/ha)"
                formControlName="grundytaForeAvv">
            </rask-input-number>
            } @else {
            <rask-input-number
                [value]="atgard.grundytaForeAvv"
                class="w-100"
                [disabled]="true"
                label="Grundyta före avverkning (m²/ha)">
            </rask-input-number>
            }
        </div>
        <div class="col-4">
            <rask-input-number [useDecimalProcessor]="true" class="w-100"
                [raskDisabledControl]="atgard.isReadonly"
                label="Grundyta efter avverkning (m²/ha)"
                formControlName="grundytaEfterAvv">
            </rask-input-number>
        </div>
        <div class="col-4">
            <rask-input-number [useDecimalProcessor]="true" class="w-100"
                [raskDisabledControl]="atgard.isReadonly"
                label="Antal f/s per h/a"
                formControlName="antalFS"
                [isDecimal]="false">
            </rask-input-number>
        </div>
        <div class="col-4">
            <rask-radiobutton-group
                [raskDisabledControl]="atgard.isReadonly"
                label="Grot-uttag"
                [buttons]="grotUttagRadioButtons"
                formControlName="grotuttagForeslaget">
            </rask-radiobutton-group>
        </div>
        }
        @if(!atgard.isGrot){
        <div class="col-4 mb-4">
            <rask-simple-selector
                [raskDisabledControl]="disableMalklass()"
                class="col-12"
                label="Målklass"
                [values]="malKlasser"
                formControlName="malklass">
            </rask-simple-selector>
        </div>
        }
        <div class="col-4 mb-4">
            <rask-input
                [raskDisabledControl]="atgard.isReadonly"
                class="w-100"
                label="Extern beteckning"
                formControlName="externBeteckning"
                [infoText]="externBeteckningInfotext"
                [maxlength]="30">
            </rask-input>
        </div>
        <div class="col-12">
            <rask-textarea
                #anteckningarTextArea
                [raskDisabledControl]="atgard.isReadonly"
                class="w-100 textarea-margin"
                label="Anteckning från planerare till avverkningsdirektiv"
                formControlName="uttagsanvisning"
                [rows]="3"
                [maxlength]="2000">
            </rask-textarea>
        </div>
        }
    </div>
</form>
}